import { connect } from "react-redux";
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import BarcodeReader from "react-barcode-reader";
import Select, { components } from "react-select";
import { useDebouncedCallback } from "use-debounce";

import { inventoryActions } from "../../../../redux/actions";
import { PRODUCT_TYPES_ENUMS } from "../../../../system/globalEnums";
import { categoriesDropdownStyle } from "../../../../assets/scss/style";
import CategoriesDropdown from "../../../../shared/components/selectDropdown/CategoriesDropdown";
import {
  toastType,
  globalConstants,
  inventoryConstants,
  categoryDropdownConstants,
  EMPTY_STRING,
} from "../../../../constants";
import {
  CustomInput,
  customToast,
  stringifyObject,
  LoadingIndicator,
  getDefaultFilterType,
  getCustomTypesOptionList,
  getCustomCategoriesOptionList,
  getCustomSubCategoriesOptionList,
  getExternalApiProductsCombineList,
  handleFetchPriceChartingApiProducts,
  createSearchInventoryApiOptionsList as createSelectOptionList,
} from "../../../../shared/utility";

const SearchInventory = (props) => {
  //-------props
  const {
    modalType,
    customTypes,
    currentStore,
    asyncSelectRef,
    isBatch = false,
    customCategories,
    addBatchInventory,
    customSubCategories,
    isScanAllowed = true,
    invoiceBatchInventory,
    isFilterRequire = true,
    isTypeDisabled = false,
    addTradeBatchInventory,
    isTradeInSearch = false,
    dropdownIndicator = true,
    setPokemonProductInReducer,
    handleMenuProductClick = false,
    placeHolder = "Search inventory...",
    defaultProductType = PRODUCT_TYPES_ENUMS.VIDEO_GAME,
    isSearchCustomProduct = false, //if true filters will also contain custom type/categories
    onSearchItemSelect = () => {},
  } = props;
  const [scanData, setScanData] = useState(placeHolder);
  const [searchProductType, setSearchProductType] = useState(
    getDefaultFilterType(customTypes, defaultProductType)
  );
  const [productCategory, setProductCategory] = useState(EMPTY_STRING);
  const [productSubCategory, setProductSubCategory] = useState(EMPTY_STRING);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  //-------load option
  const loadOptions = useDebouncedCallback(async (inputValue) => {
    setIsloading(true);
    const searchValue = inputValue;

    const combinedList = await getExternalApiProductsCombineList({
      isBatch,
      searchValue,
      currentStore,
      productCategory,
      customCategories,
      searchProductType,
      productSubCategory,
      isSearchCustomProduct,
    });

    const selectedOptions = createSelectOptionList(combinedList);
    if (
      selectedOptions.length === 1 &&
      selectedOptions[0].value.upc === inputValue
    ) {
      handleItemSelect(selectedOptions[0]);
    } else if (scanData === inputValue && inputValue) {
      customToast("Barcode doesn't exist in inventory", toastType.ERROR);
    } else {
      setOptions(selectedOptions);
    }
    setScanData(placeHolder); // after search result reset the search inventory placeHolder
    setIsloading(false);
  }, 1000);

  //---------handle scan
  const handleScan = async (data) => {
    if (!isScanAllowed) {
      return;
    }

    if (asyncSelectRef.current) {
      asyncSelectRef.current.clearValue();
    }
    setScanData(data);
    if (data) {
      loadOptions(data);
    }
  };

  const handleError = (error) => {};

  //-------handle item select
  const handleItemSelect = (product) => {
    let currentBatchLength = 0;

    if (modalType) {
      if (modalType === inventoryConstants.INVENTORY_BATCH_MODAL) {
        currentBatchLength = addBatchInventory?.length || 0;
      } else if (modalType === inventoryConstants.TRADE_BATCH_MODAL) {
        currentBatchLength = addTradeBatchInventory?.length || 0;
      } else if (modalType === inventoryConstants.INVOICE_BATCH_MODAL) {
        currentBatchLength = invoiceBatchInventory?.length || 0;
      }

      if (currentBatchLength >= inventoryConstants.BATCH_MODAL_MAX_LENGTH) {
        customToast(
          `You can only add ${inventoryConstants.BATCH_MODAL_MAX_LENGTH} items at a time`,
          toastType.ERROR
        );
        return;
      }
    }

    if (product?.value) {
      setInputValue("");
      setOptions([]);
      if (handleMenuProductClick) {
        handleMenuProductClick(product.value);
      } else {
        if (
          product?.value?.sourceApi === inventoryConstants.PRICECHARTING_API
        ) {
          //getPricechartingProductById(product?.value, product.value.product_id);
          setPokemonProductInReducer(
            product?.value,
            product?.value?.productObject,
            isBatch // in batch case image is fetched later (getInStockProductBatchModal) so don't fetch on product insertion in modal
          );
        } else if (
          product?.value?.sourceApi === inventoryConstants.TCG_PLAYER_API
        ) {
          setPokemonProductInReducer(
            product?.value,
            product?.value?.productObject
          );
        } else if (
          product?.value?.sourceApi === inventoryConstants.STORE_CUSTOM_PRODUCT
        ) {
          setPokemonProductInReducer(
            product?.value,
            product?.value?.productObject
          );
        }
      }
    }
  };

  const handleInputValueChange = (value, { action }) => {
    if (action === "input-change") {
      setInputValue(value);
      if (value) {
        setIsloading(true);
        loadOptions(value);
      }
    }
  };

  const handleOnFocus = (e) => {
    setOptions([]);
    const inputElement = asyncSelectRef.current.inputRef;
    if (e.target.value) {
      setIsloading(true);
      loadOptions(e.target.value);
      if (asyncSelectRef?.current) {
        const length = inputElement.value.length;
        inputElement.setSelectionRange(length, length);
      }
    }
  };

  const handleDoubleClick = () => {
    const inputElement = asyncSelectRef.current.inputRef;
    if (asyncSelectRef?.current) {
      const length = inputElement.value.length;
      inputElement.setSelectionRange(0, length);
    }
  };

  return (
    <>
      <div>
        <BarcodeReader onError={handleError} onScan={handleScan} />
      </div>
      <Row>
        <Col
          md={isFilterRequire ? (isTradeInSearch ? 12 : 6) : 12}
          className={isTradeInSearch ? "order-4" : ""}
          onDoubleClick={handleDoubleClick}
        >
          <Select
            value={""}
            options={options}
            className={`w-100`}
            ref={asyncSelectRef}
            filterOption={false}
            isLoading={isLoading}
            placeholder={scanData}
            openMenuOnFocus={true}
            inputValue={inputValue}
            onFocus={handleOnFocus}
            getOptionLabel={(e) => e.label}
            styles={{
              ...categoriesDropdownStyle,
              input: (provided) => ({
                ...provided,
                maxWidth: "25vw",
                overflow: "hidden",
                position: "relative",
                marginLeft: "2em", // Space for the icon
              }),
            }}
            onInputChange={handleInputValueChange}
            getOptionValue={(e) => stringifyObject(e.value)}
            onChange={(selectedOption) => {
              handleItemSelect(selectedOption);
              onSearchItemSelect();
            }}
            components={
              dropdownIndicator
                ? {
                    IndicatorSeparator: () => null,
                    Input: CustomInput,
                    LoadingIndicator,
                  }
                : {
                    IndicatorSeparator: () => null,
                    DropdownIndicator: () => "",
                    Input: CustomInput,
                    LoadingIndicator,
                  }
            }
            noOptionsMessage={() => {
              return "No Product Found";
            }}
          />
        </Col>
        {isFilterRequire && (
          <>
            <Col
              md={isTradeInSearch ? 4 : 2}
              className={isTradeInSearch ? "order-1 mb-2" : "pe-md-0"}
            >
              <CategoriesDropdown
                placeholder="Type"
                isClearable={false}
                noOptionsMessage="No Type Found"
                options={getCustomTypesOptionList(
                  customTypes.filter((item) =>
                    isSearchCustomProduct ? true : !item.isCustom
                  )
                )}
                SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
                handleChange={(selectedOption) => {
                  setSearchProductType(selectedOption);
                  setProductCategory(EMPTY_STRING);
                  asyncSelectRef?.current?.focus();
                }}
                defaultValue={getDefaultFilterType(
                  customTypes,
                  defaultProductType
                )}
                wrapperClassname={isTradeInSearch ? "trade-search-filter" : ""}
                disabled={isTypeDisabled}
              />
            </Col>
            <Col
              md={isTradeInSearch ? 4 : 2}
              className={isTradeInSearch ? "ps-md-0 order-2  mb-2" : "pe-md-0"}
            >
              <CategoriesDropdown
                placeholder="Category"
                value={productCategory}
                options={getCustomCategoriesOptionList(
                  customCategories.filter((item) =>
                    isSearchCustomProduct ? true : !item.isCustom
                  ),
                  searchProductType?.value,
                  searchProductType?.label
                )}
                noOptionsMessage="No Category Found"
                SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
                handleChange={(selectedOption) => {
                  setProductCategory(selectedOption || EMPTY_STRING);
                  setProductSubCategory(EMPTY_STRING);
                  asyncSelectRef?.current?.focus();
                }}
                wrapperClassname={isTradeInSearch ? "trade-search-filter" : ""}
              />
            </Col>
            <Col
              md={isTradeInSearch ? 4 : 2}
              className={isTradeInSearch ? "ps-md-0 order-3  mb-2" : "pe-md-0"}
            >
              <CategoriesDropdown
                options={getCustomSubCategoriesOptionList(
                  customSubCategories,
                  productCategory?.value,
                  searchProductType?.label,
                  searchProductType?.value,
                  !isSearchCustomProduct,
                  customCategories,
                  customTypes
                )}
                value={productSubCategory}
                handleChange={(selectedOption) => {
                  setProductSubCategory(selectedOption || EMPTY_STRING);
                  asyncSelectRef?.current?.focus();
                }}
                noOptionsMessage="No SubCategory Found"
                placeholder="Sub-Category"
                SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
                wrapperClassname={isTradeInSearch ? "trade-search-filter" : ""}
              />
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  addBatchInventory: state.inventory.addBatchInventory,
  invoiceBatchInventory: state.invoice.invoiceBatchInventory,
  customSubCategories: state.itemOrganization.customSubCategories,
  addTradeBatchInventory: state.transaction.addTradeBatchInventory,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getPricechartingProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getPricechartingProductById(productMetaData, productId)
    ),
  setPokemonProductInReducer: (...args) =>
    dispatch(inventoryActions.setPokemonProductInReducer(...args)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(SearchInventory);
